<template>
  <section class="criar">
    <div class="quadro">
      <div class="tela">
        <div class="icone">
          <Svgs nome="cursor" />
        </div>
        <p>Suas áreas de membros</p>
      </div>

      <div class="plano">
        <img :src="`https://central-statics.nyc3.digitaloceanspaces.com/global/planos/${tipoPlanoConvertido || 'free'}.png`" />
        <p>{{ storeAreas.areas?.length }} de {{ limitePlano }} Áreas criadas</p>
      </div>

      <div class="dados">
        <div class="tag on">
          <Svgs nome="check" />
          <p>{{ storePainel.estatisticas?.quantidadeAreas }} online</p>
        </div>
        <div class="tag www">
          <Svgs nome="usuarios" />
          <p>{{ storePainel.estatisticas?.quantidadeAlunos }} alunos</p>
        </div>
        <div class="tag off">
          <Svgs nome="dominio" />
          <p>{{ quantidadeDominios }}</p>
        </div>
      </div>

      <button class="upgrade" @click="router.push('/planos')" v-if="limiteAtingido(storePerfil.usuario?.assinatura?.plano, storeAreas.areas?.length)">
        <Svgs nome="estrela" />
        <p>Fazer upgrade</p>
      </button>
      <div class="criar" ref="criar" v-else>
        <button class="abrir" @click="novaArea()">
          <p>Nova área</p>
          <Svgs nome="mais" />
        </button>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed, reactive, onMounted, onUnmounted, ref } from 'vue'
import { useStorePerfil, useStoreAreas, useStorePainel, useStoreModal } from '@stores'
import { useRouter } from 'vue-router'
import Svgs from '@svgs'

const storePerfil = useStorePerfil()
const storeAreas = useStoreAreas()
const storePainel = useStorePainel()
const storeModal = useStoreModal()
const router = useRouter()
const criar = ref(null)

const state = reactive({
  loading: false,
  mostrarCriar: false
})

const limitePlano = computed(() => {
  const plano = storePerfil.usuario?.assinatura?.plano
  switch (plano) {
    case 'free':
      return 1
    case 'essencial':
      return 1
    case 'pro':
      return 3
    case 'expert':
      return 10
    default:
      return 1
  }
})

const tipoPlanoConvertido = computed(() => {
  const tipo = storePerfil.usuario?.assinatura?.plano
  if (!tipo) return 'free'

  const tiposPlano = {
    expert: 'diamond',
    pro: 'gold',
    essencial: 'silver',
    free: 'free'
  }

  return tiposPlano[tipo.toLowerCase()] || 'free'
})

const planosLimites = {
  free: 1,
  essencial: 1,
  pro: 3,
  expert: 15,
  unlimited: 1000
}

function fecharSeClicarFora(event) {
  if (criar.value && !criar.value.contains(event.target)) {
    state.mostrarCriar = false
  }
}

const limiteAtingido = (tipo, totalAreas) => {
  const limite = planosLimites[tipo] || 0
  return totalAreas >= limite
}

function novaArea() {
  storeModal.abrirModal('criarArea', 'foguete', 'Criar nova área de membros')
}

const formatarQuantidade = (quantidade, singular, plural) => {
  return quantidade === 1 ? singular : plural
}

const quantidadeDominios = computed(() => {
  const areas = storeAreas.areas || []
  const quantidade = areas.filter((area) => area.dominioPersonalizado).length
  return `${quantidade} ${formatarQuantidade(quantidade, 'domínio', 'domínios')}`
})

onMounted(() => {
  document.addEventListener('click', fecharSeClicarFora)
})

onUnmounted(() => {
  document.removeEventListener('click', fecharSeClicarFora)
})
</script>

<style scoped>
section.criar {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0 20px;
  height: 80px;
  border-bottom: 1px solid var(--cor-escuro-3);
}
.quadro {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.quadro .tela {
  display: flex;
  align-items: center;
}
.quadro .tela .icone {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background-color: var(--cor-escuro-4);
  margin: 0 10px 0 0;
}
.quadro .tela .icone svg {
  width: 15px;
  min-width: 15px;
  fill: var(--cor-branco);
}
.quadro .tela p {
  font-family: var(--medium);
  font-size: var(--f2);
  color: var(--cor-branco);
}
.quadro .plano {
  display: flex;
  align-items: center;
}
.quadro .plano img {
  width: 25px;
  min-width: 25px;
  margin: 0 5px 0 0;
}
.quadro .plano p {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-escuro-6);
  width: 100%;
}
.quadro .dados {
  display: flex;
  align-items: center;
}
.quadro .dados .tag {
  display: flex;
  align-items: center;
  margin: 0 20px 0 0;
}
.quadro .dados .tag p {
  font-family: var(--regular);
  font-size: var(--f1);
  color: var(--cor-escuro-6);
}
.quadro .dados .tag svg {
  width: 15px;
  min-width: 15px;
  margin: 0 10px 0 0;
}
.quadro .dados .tag.on svg {
  fill: var(--cor-verde);
}
.quadro .dados .tag.off svg {
  fill: var(--cor-vermelho);
}
.quadro .dados .tag.www svg {
  fill: var(--cor-laranja);
}
.quadro button.abrir {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 10px 13px 15px;
  width: 150px;
  border-radius: 8px;
  background-color: var(--cor-marca);
  position: relative;
  transition: all 0.3s;
}
.quadro button.abrir:hover {
  background-color: var(--cor-marca-escuro);
}
.quadro button.abrir svg {
  width: 15px;
  min-width: 15px;
  fill: var(--cor-branco);
  transition: all 0.3s;
}
.quadro button.abrir p {
  font-family: var(--bold);
  font-size: var(--f1);
  color: var(--cor-branco);
  transition: all 0.3s;
}
.quadro button.abrir:disabled svg {
  fill: transparent;
}
.quadro button.abrir:disabled p {
  color: transparent;
}
.quadro button.abrir:disabled span {
  opacity: 1;
  visibility: visible;
}
.quadro button.abrir span {
  width: 20px;
  height: 20px;
  border: 2px solid var(--cor-branco);
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: girando 1s linear infinite;
  opacity: 0;
  visibility: hidden;
  position: absolute;
  left: 45%;
  top: 30%;
  transition: all 0.3s;
}
.quadro button.upgrade {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 25px;
  border-radius: 8px;
  background-color: var(--cor-laranja);
  position: relative;
  transition: all 0.3s;
}
.quadro button.upgrade:hover {
  background-color: var(--cor-laranja-escuro);
}
.quadro button.upgrade svg {
  width: 15px;
  min-width: 15px;
  margin: 0 10px 0 0;
  fill: var(--cor-branco);
  transition: all 0.3s;
}
.quadro button.upgrade p {
  font-family: var(--bold);
  font-size: var(--f1);
  color: var(--cor-branco);
  transition: all 0.3s;
}
.quadro .criar {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.quadro .criar .lista {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: absolute;
  top: 50px;
  right: 0;
  z-index: 2;
  width: 100%;
  background-color: var(--cor-escuro-1);
  border: 1px solid var(--cor-marca);
  border-radius: 10px;
  padding: 10px 20px;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform: translate(0, 30px);
  transition: all 0.3s;
}
.quadro .criar .lista.mostrar {
  opacity: 1;
  visibility: visible;
  pointer-events: all;
  transform: translate(0, 0);
}
.quadro .criar .lista button {
  display: flex;
  align-items: center;
  background-color: transparent;
  padding: 10px 0;
}
.quadro .criar .lista button:hover p {
  color: var(--cor-branco);
}
.quadro .criar .lista button:hover img {
  transform: scale(1.05);
}
.quadro .criar .lista button p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-escuro-6);
  transition: all 0.3s;
}
.quadro .criar .lista button img {
  width: 20px;
  margin: 0 10px 0 0;
  transition: all 0.3s;
}
/* Responsivo */
@media screen and (max-width: 1024px) {
  section.criar {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 50px 0 15px 0;
    height: 130px;
  }
  .quadro {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .quadro .tela {
    display: none;
    align-items: center;
  }
  .quadro .dados {
    padding: 0 20px;
  }
  .quadro .plano {
    display: flex;
    align-items: center;
    background-color: var(--cor-escuro-2);
    width: 100%;
    padding: 10px 20px;
  }
  .quadro .plano img {
    width: 20px;
    min-width: 20px;
  }
  .quadro .dados {
    margin: 10px 0 0 0;
  }
  .quadro button.abrir {
    padding: 8px 8px 8px 12px;
    width: 90px;
    border-radius: 5px;
  }
  .quadro button.abrir svg {
    width: 11px;
    min-width: 11px;
  }
  .quadro button.abrir p {
    font-size: var(--f0);
  }
  .quadro button.upgrade {
    padding: 8px 8px 8px 12px;
    border-radius: 5px;
    position: fixed;
    top: 10px;
    right: 55px;
    z-index: 10;
  }
  .quadro button.upgrade svg {
    width: 11px;
    min-width: 11px;
  }
  .quadro button.upgrade p {
    font-size: var(--f0);
  }

  .quadro button.abrir span {
    width: 15px;
    height: 15px;
  }
  .quadro .criar {
    position: fixed;
    top: 10px;
    right: 55px;
    z-index: 10;
  }
  .quadro .criar .lista {
    top: 40px;
    z-index: 2;
    width: 180px;
    min-width: 180px;
    padding: 10px 15px;
    transform: translate(0, 20px);
  }
  .quadro .criar .lista button {
    padding: 8px 0;
  }
  .quadro .criar .lista button p {
    font-size: var(--f1);
  }
  .quadro .criar .lista button svg {
    width: 11px;
    min-width: 11px;
    margin: 0 8px 0 0;
  }
}
</style>
